import { StdResponse, bimAxios } from "@/config/axios"
import { Sensor, DeviceCollectionHistory, SensorParameter, DeviceTestConnectHistory, DeviceInstallHistory } from "@/commons/interface/device/sensor";
import qs from "qs";

export function getSensors(projectUuid: string, params?: {}): Promise<StdResponse<any>> {
    return bimAxios.get(`/project/${projectUuid}/sensors`, {
        params: {
            ...params,
        }
    })
}

export function getSensorDetail(id: number, params?: {}): Promise<StdResponse<any>> {
    return bimAxios.get(`/sensors/${id}`, {
        params: {
            ...params,
        }
    })
}

export function createSensor(data: Sensor, params?: {}): Promise<StdResponse<any>> {
    return bimAxios.post(`/sensors`, data, {
        params: {
            ...params,
        }
    })
}

export function createSensors(data: Sensor[], params?: {}): Promise<StdResponse<any>> {
    return bimAxios.post(`/sensors/multi`, data, {
        params: {
            ...params,
        }
    })
}

export function updateSensor(id: number, data: Sensor, params?: {}): Promise<StdResponse<any>> {
    return bimAxios.put(`/sensors/${id}`, data, {
        params: {
            ...params,
        }
    })
}

export function deleteSensorByPrimitiveUuid(primitiveUuid: string, params?: {}): Promise<StdResponse<any>> {
    return bimAxios.delete(`/primitives/${primitiveUuid}/delete-sensor`, {
        params: {
            ...params,
        }
    })
}

export function deleteSensor(id: number, params?: {}): Promise<StdResponse<any>> {
    return bimAxios.delete(`/sensors/${id}`, {
        params: {
            ...params,
        }
    })
}

export function deleteSensors(data: number[], params?: {}): Promise<StdResponse<any>> {
    return bimAxios.post(`/sensors/delete-multi`, data, {
        params: {
            ...params,
        }
    })
}

export function getSensorByPrimitiveUuid(primitiveUuid: string, params?: {}): Promise<StdResponse<any>> {
    return bimAxios.get(`/primitives/${primitiveUuid}/sensors`, {
        params: {
            ...params,
        }
    })
}

export function queryCameraPlay(sensorId: number, paramId: number, params?: {}): Promise<StdResponse<any>> {
    return bimAxios.get(`/sensors/${sensorId}/params/${paramId}/camera-play`, {
        params: params
    })
}

export function getImageStr(sensorParamId: number, params?: {}): Promise<StdResponse<any>> {
    return bimAxios.get(`/sensor-params/${sensorParamId}/base64-image`, {
        params: params
    })
}



export function findSensorParameterDtoBySensorIds(sensorIds: number[], params?: {}): Promise<StdResponse<any>> {
    return bimAxios.get(`/sensor-params`, {
        params: {
            sensorIds: sensorIds,
            ...params,
        },
        paramsSerializer: params => {
            return qs.stringify(params, { arrayFormat: 'comma' })
        }
    })
}

export function updateSensorParameter(id: number, data: SensorParameter, params?: {}): Promise<StdResponse<any>> {
    return bimAxios.put(`/sensor-params/${id}`, data, {
        params: {
            ...params,
        },
    })
}

export function getSensorTestBySensorId(sensorId: number, params?: {}): Promise<StdResponse<any>> {
    return bimAxios.get(`/sensors/${sensorId}/test`, {
        params: {
            ...params,
        },
    })
}

export function addSensorTestHistory(projectUuid: string, sensorId: number, data: DeviceTestConnectHistory, params?: {}): Promise<StdResponse<any>> {
    return bimAxios.post(`/projects/${projectUuid}/sensors/${sensorId}/test`, data, {
        params: {
            ...params,
        },
    })
}

export function deleteSensorTestBySensorId(sensorId: number, params?: {}): Promise<StdResponse<any>> {
    return bimAxios.delete(`/sensors/${sensorId}/test`, {
        params: {
            ...params,
        },
    })
}

export function deleteSensorTestByProjecdtId(projectUuid: string, params?: {}): Promise<StdResponse<any>> {
    return bimAxios.delete(`/projects/${projectUuid}/sensor-test`, {
        params: {
            ...params,
        },
    })
}

export function getSensorCollectionBySensorId(sensorId: number, params?: {}): Promise<StdResponse<any>> {
    return bimAxios.get(`/sensors/${sensorId}/collection`, {
        params: {
            ...params,
        },
    })
}

export function addSensorCollectionHistory(projectUuid: string, sensorId: number, data: DeviceCollectionHistory, params?: {}): Promise<StdResponse<any>> {
    return bimAxios.post(`/projects/${projectUuid}/sensors/${sensorId}/collection`, data, {
        params: {
            ...params,
        },
    })
}

export function deleteSensorCollectionBySensorId(sensorId: number, params?: {}): Promise<StdResponse<any>> {
    return bimAxios.delete(`/sensors/${sensorId}/collection`, {
        params: {
            ...params,
        },
    })
}

export function deleteSensorCollectionByProjecdtId(projectUuid: string, params?: {}): Promise<StdResponse<any>> {
    return bimAxios.delete(`/projects/${projectUuid}/sensor-collection`, {
        params: {
            ...params,
        },
    })
}

export function getSensorInstallBySensorId(sensorId: number, params?: {}): Promise<StdResponse<any>> {
    return bimAxios.get(`/sensors/${sensorId}/installs`, {
        params: {
            ...params,
        },
    })
}

export function addSensorInstallHistory(projectUuid: string, sensorId: number, data: DeviceInstallHistory, params?: {}): Promise<StdResponse<any>> {
    return bimAxios.post(`/projects/${projectUuid}/sensors/${sensorId}/installs`, data, {
        params: {
            ...params,
        },
    })
}



